import { IApplicationState } from '../../types/redux';

export const selectBanner = (state: IApplicationState) => {
  return state.promosPage.banner;
};
